import { MEMBER_JOIN_STATUS } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

export const useIsNewUser = () => {
  const isNewUser = useAuthStore(({ myInfo }) => {
    const memberJoinStatus = myInfo?.memberJoinStatus;

    return memberJoinStatus
      ? [MEMBER_JOIN_STATUS.NO_PHONE, MEMBER_JOIN_STATUS.NO_NICKNAME].includes(
          memberJoinStatus,
        )
      : false;
  });

  return isNewUser;
};
